// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle.db55840a5fe1d646fe8ab8de642288e3a6f49dc3.js";
};